import { render } from "./TextListPage.vue?vue&type=template&id=394788e2&ts=true"
import script from "./TextListPage.ts?vue&type=script&lang=ts"
export * from "./TextListPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__